import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { Topic } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useTopic = (
  projectId: string,
  topicName: string,
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, Topic>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, Topic>({
    queryKey: ["projects", projectId, "topics", topicName],
    queryFn: async (): Promise<Topic> => {
      const response = await api.get<Topic>(`/projects/${projectId}/topics/${encodeURIComponent(topicName)}`);
      return camelize(response.data);
    },
    ...options
  });
};
